
export const images = [
    {
        "title": "Bellicose Entity, Blind Self-Destruction",
        "description": "Acrylic on Canvas",
        "filename": "Bellicose-Entity-Blind-SelfDestruction",
        "size": "36 x 48 in"
    },
    {
        "title": "Dakotah Quainter",
        "description": "Pastels & Sanguine Charcoal on Paper",
        "filename": "Dakotah-Quainter",
        "size": "18 x 15 in"
    },
    {
        "title": "♫ Raske drenge, grind at dræbe det er vor lyst ♫",
        "description": "Acrylic on Canvas",
        "filename": "grind",
        "size": "20 x 25 in"
    },
    {
        "title": "Nihilistic Breakthrough",
        "description": "Acrylic on Canvas",
        "filename": "NihilistBreakthrough",
        "size": " 48 x 36 in"
    },
    {
        "title": "Industrial Orchestrator: Man As Instrument Of Progress",
        "description": "Acrylic on Canvas",
        "filename": "Industrial-Orchestrator",
        "size": "36 x 48 in"
    },
    {
        "title": "Recurring Demons",
        "description": "Acrylic on Canvas",
        "filename": "Recurring_Demons",
        "size": "36 x 36 in"
    },
    {
        "title": "Las 3 Fridas",
        "description": "Pastel Pencils on Paper",
        "filename": "Las-3-Fridas",
        "size": "19 x 15 in"
    },
    {
        "title": "Jeanine DeLuna",
        "description": "Pastels on Paper",
        "filename": "Jeanine-DeLuna",
        "size": "16 x 12 in"
    },
    {
        "title": "Lost in TRANSlation",
        "description": "Acrylic on Canvas",
        "filename": "Lost-in-TRANS-lation",
        "size": "24 x 24 in"
    },
    {
        "title": "Lauren Stout",
        "description": "Sepia Charcoal on Paper",
        "filename": "LaurenStout",
        "size": "19 x 14 in"
    },
    {
        "title": "Painting Dynamics",
        "description": "Oil on Canvas",
        "filename": "painting_dynamics",
        "size": "40 x 40 in"
    },
    {
        "title": "Ballet Folklorico III",
        "description": "Oil on Canvas",
        "filename": "BalletFolklorico3",
        "size": "40 x 40 in"
    }
]
